import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const EditVehicleTypeForm = ({
    fields = [],
    values = {},
    errors = {},
    handleChange = () => {},
    handleSubmit = () => {},
    loading = false,
    title = "Vehicle Type",
}) => {
    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Update {title}</HeadingOne>
        }>
            {fields.map((field) => (
                <FormInput
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                />
            ))}

            <FormSubmitButton
                label={`Update ${title}`}
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditVehicleTypeForm;
